module.exports = __webpack_public_path__ + "static/media/13_l_tkan_8.91_86.48.d5c7586c.png";